module.exports = __webpack_public_path__ + "img/sq_virus.d644bf93.jpg";